/* eslint-disable no-unused-vars */

import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "./axiosInstance";
import { setLogout } from "../redux/loginForm";
import { decryptData } from "./encrypted";
import { imageUpload } from "./ApiRoutesFile";

export const token = localStorage.getItem("auction_portal");

const ApiFunction = () => {
  const encryptedUser = useSelector((state) => state.auth?.userData);
  const userData = decryptData(encryptedUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const token = localStorage.getItem('accounting_company_sass_token');
  const handleUserLogout = () => {
    // Clear all auth data
    localStorage.removeItem("auction_portal");
    dispatch(setLogout());
    navigate("/auth/login", { replace: true });
    message.info("Your session has expired, please login again");
  };

  // Define headers
  const header1 = {
    "Content-Type": "application/json",
    // "x-auth-token": token,
  };

  const header2 = {
    "Content-Type": "multipart/form-data",
    // "x-auth-token": token,
  };

  // API Functions
  const get = async (endpoint, options = {}) => {
    try {
      const { headers = header1, signal, ...otherOptions } = options;
      const response = await axiosInstance.get(endpoint, {
        headers: {
          ...headers,
        },
        signal,
        ...otherOptions,
      });
      return response.data;
    } catch (error) {
      // Don't log cancelled requests as errors - they are normal behavior
      if (error.name === 'CanceledError' || error.name === 'AbortError' || error.message?.includes('canceled')) {
        console.log("Request was cancelled - this is normal when typing in search field");
        throw error; // Still throw so components can handle it
      }
      
      console.error("Error in GET request:", error);
      if (error.response?.status === 401) {
        handleUserLogout();
      }
      throw error;
    }
  };

  const post = async (endpoint, apiData, headers = header1) => {  // endpoint is auth
    try {
       console.log("apiData");
      console.log(apiData);
      const response = await axiosInstance.post(endpoint, apiData, {
        headers: {
          ...headers,
        },
      });
      console.log("response");
      console.log(response);

      return response.data;
    } catch (error) {
      // Don't log cancelled requests as errors - they are normal behavior
      if (error.name === 'CanceledError' || error.name === 'AbortError' || error.message?.includes('canceled')) {
        console.log("Request was cancelled - this is normal when typing in search field");
        throw error; // Still throw so components can handle it
      }
      
      console.error("Error in POST request:", error);
      if (error.response?.status === 401) {
        handleUserLogout();
      }
      throw error;
    }
  };

  const deleteData = async (endpoint, headers = header1) => {
    try {
      const response = await axiosInstance.delete(endpoint, {
        headers: {
          ...headers,
        },
      });
      return response.data;
    } catch (error) {
      // Don't log cancelled requests as errors - they are normal behavior
      if (error.name === 'CanceledError' || error.name === 'AbortError' || error.message?.includes('canceled')) {
        console.log("Request was cancelled - this is normal when typing in search field");
        throw error; // Still throw so components can handle it
      }
      
      console.error("Error in DELETE request:", error);
      if (error.response?.status === 401) {
        handleUserLogout();
      }
      throw error;
    }
  };

  const put = async (endpoint, apiData, headers = header1) => {
    try {
      const response = await axiosInstance.put(endpoint, apiData, {
        headers: {
          ...headers,
        },
      });
      return response.data;
    } catch (error) {
      // Don't log cancelled requests as errors - they are normal behavior
      if (error.name === 'CanceledError' || error.name === 'AbortError' || error.message?.includes('canceled')) {
        console.log("Request was cancelled - this is normal when typing in search field");
        throw error; // Still throw so components can handle it
      }
      
      console.error("Error in PUT request:", error);
      if (error.response?.status === 401) {
        handleUserLogout();
      }
      throw error;
    }
  };

  const uploadFile2 = async ({ data }) => {
    try {
      const res = await axiosInstance.post(imageUpload, data, {
        headers: {
          ...header2,
        },
      });
      // // console.log(res.data, "res");
      return res?.data;
    } catch (error) {
      throw error;
    }
  };

  return {
    get,
    post,
    deleteData,
    uploadFile2,
    put,
    header1,
    header2,
    userData,
  };
};

export default ApiFunction;
